import { useState, useEffect } from "react";
import { Sun, Moon } from "lucide-react";

const KEY = "sd_theme";

function initialLight() {
  if (typeof window === "undefined") return false;
  const saved = localStorage.getItem(KEY);
  if (saved) return saved === "light";
  return window.matchMedia?.("(prefers-color-scheme: light)").matches ?? false;
}

export default function ThemeToggle({ className = "", testid = "theme-toggle" }) {
  const [light, setLight] = useState(initialLight);

  useEffect(() => {
    document.documentElement.classList.toggle("light", light);
    localStorage.setItem(KEY, light ? "light" : "dark");
  }, [light]);

  return (
    <button
      data-testid={testid}
      onClick={() => setLight((v) => !v)}
      aria-label={light ? "Passer en mode sombre" : "Passer en mode clair"}
      className={`flex h-9 w-9 items-center justify-center rounded-full border border-gold/50 text-gold transition-colors hover:bg-gold/10 ${className}`}
    >
      {light ? <Moon className="h-4 w-4" strokeWidth={1.6} /> : <Sun className="h-4 w-4" strokeWidth={1.6} />}
    </button>
  );
}
